module.exports = require('./modules/components/Redirect');



//////////////////
// WEBPACK FOOTER
// ./~/react-router/Redirect.js
// module id = 206
// module chunks = 0